import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import * as connectionsApi from '@/api/connections';

export const connectionKeys = {
  all: ['connections'] as const,
  list: () => [...connectionKeys.all, 'list'] as const,
};

export function useConnections() {
  return useQuery({
    queryKey: connectionKeys.list(),
    queryFn: () => connectionsApi.getConnections(),
  });
}

export function useRevokeConnection() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (grantId: string) => connectionsApi.revokeConnection(grantId),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: connectionKeys.all });
    },
  });
}
